import CustomButtom from "common/components/Button/Button"
import { AppContext } from "common/context/WithAppWrapper"
import { Button } from "primereact/button"
import { useContext } from "react"
import { useHistory } from "react-router-dom"
import { SIGN_UP } from "routes/RoutePaths"

const Welcome = ({ onHide }: $TSMigrationFixMe) => {
  const history = useHistory()
  // @ts-expect-error TS(2339): Property 'settings' does not exist on type 'unknow...
  const { settings } = useContext(AppContext)

  return (
    <div className='container'>
      <div className='tw-flex tw-justify-center tw-mb-6'>
        <img
          style={{ width: "50%" }}
          src={settings.erp}
          alt='Logo de ERP'
        />
      </div>

      <h5>Bienvenido a {settings.title}</h5>

      <p className='mt-4'>
        Si quieres{" "}
        <strong>
          mejorar la gestión en la recepción y emisión de tus facturas
        </strong>{" "}
        teniendo el control desde una plataforma única en lugar de intercambiar
        infinidad de correos electrónicos o quieres{" "}
        <strong>
          descargarlos en formatos estructurados para importarlos en tu sistema
          de gestión contable
        </strong>
        .
      </p>

      <p>¡Regístrate en {settings.title}!</p>

      <div className='d-flex px-1 justify-content-center mt-5'>
        <Button
          onClick={onHide}
          style={{ width: "400px" }}
          className='p-button-raised p-button-text mr-1 button'
        >
          Solo quiero el PDF
        </Button>

        <CustomButtom
          onClick={() => history.push(SIGN_UP)}
          style={{ width: "400px" }}
          className='!tw-bg-primary tw-py-3 tw-px-6 tw-ml-1'
        >
          Registrarme sin coste
        </CustomButtom>
      </div>
    </div>
  )
}

export default Welcome
